export const state = () => ({
  newBookIsLoading: false, // yeni ürün loadingi
  bookListRequested: false, // daha önce ürün verisi çekilmiş mi?
  booksAreLoading: true, // ürünler listesi loadingi
  books: [], // ürünler listesi
  count: 0, // kaç adet ürün bulunuyor bilgisi.
  page: 1, // sayfa bilgisi
  selectedBook: null,
})
export const getters = {
  getBooks: (state) =>
    state.books
      .filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.id === value.id)
      )
      .filter((c) => c.page === state.page),
  getBooksCount: (state) => state.count,
  getBooksLoading: (state) => state.booksAreLoading,
  getSelectedBook: (state) => state.selectedBook,
  getBookById: (state) => (id) => {
    if (state.selectedBook && String(state.selectedBook.id) === String(id)) {
      return state.selectedBook
    }
    return state.books.find((b) => String(b.id) === String(id)) || null
  },
}
export const mutations = {
  SET_PAGE(state, payload) {
    state.page = payload
  },
  SET_SELECTED_BOOK(state, payload) {
    state.selectedBook = payload
  },
  SET_CLEAR_IT(state) {
    state.books = []
    state.newBookIsLoading = false
    state.bookListRequested = false
    state.booksAreLoading = true
    state.count = 0
    state.selectedBook = null
  },
  // ürünlerin loadingi
  SET_BOOKS_ARE_LOADING(state, payload) {
    state.booksAreLoading = payload
  },
  // ürünleri projeye ekle
  SET_BOOKS(state, payload) {
    if (!state.bookListRequested) state.books = []
    if (payload.search !== '' || payload.categoryId !== -1) {
      state.books = []
      state.bookListRequested = false
    } else state.bookListRequested = true
    state.books = [...state.books, ...payload.data]
    state.count = payload.count
  },
}
export const actions = {
  // ürünleri getir
  async GET_BOOKS(
    { state, commit },
    { page = 1, search = '', limit = 12, categoryId = -1, currency }
  ) {
    commit('SET_PAGE', page)
    // cash tutulması istenmedi. aşağıdaki if bloğu cash bloğunu çalıştırır.
    // if (
    //   state.books.length !== 0 &&
    //   (search === '') & state.bookListRequested &&
    //   state.books.map((book) => book.page).includes(page) &&
    //   categoryId === -1
    // )
    //   return state.books.filter((c) => c.page === state.page) // daha önce liste çekilmişse return at.
    commit('SET_BOOKS_ARE_LOADING', true)
    const response = await this.$api.get(
      `UserBooks?page=${page}&searchKey=${search}&currency=${currency}&limit=${limit}${
        categoryId === -1 ? '' : `&categoryId=${categoryId}`
      }`
    )
    if (response.message === 'OK') {
      commit('SET_BOOKS', {
        count: response.data.count || 0,
        search,
        categoryId,
        data: response.data.items.map((d) => {
          // .items gelecek.
          return {
            ...d,
            page,
            type: 2,
          }
        }),
      })
      commit('SET_BOOKS_ARE_LOADING', false)
      return response.data
    } else
      commit('SET_BOOKS', {
        count: response.data.count || 0,
        search,
        categoryId,
        data: [],
      })
    commit('SET_BOOKS_ARE_LOADING', false)
    return []
  },
  async FIND_BOOK({ getters, commit }, { id, currency }) {
    const existing = getters.getBookById(id)
    if (existing) {
      commit('SET_SELECTED_BOOK', existing)
      return existing
    }
    const response = await this.$api.get(
      `UserBooks?page=1&searchKey=&currency=${currency}&limit=100`
    )
    if (response.message !== 'OK') return null
    const found = (response.data.items || []).find(
      (b) => String(b.id) === String(id)
    )
    if (found) {
      const item = { ...found, type: 2 }
      commit('SET_SELECTED_BOOK', item)
      return item
    }
    return null
  },
}
